/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import React from 'react';
import { ISzfProductListPageViewProps } from './szf-product-list-page';
import { Category, TextValueTranslation } from '@msdyn365-commerce/retail-proxy';
import { IFestivalCategory, IFestivalActivitiesStaticSubNavItems } from '../../utilities/interfaces';
import { Button } from '@msdyn365-commerce-modules/utilities';
import { msdyn365Commerce } from '@msdyn365-commerce/core';
import { CalendarSVG, FestivalSVG } from '../../utilities/icons';

export default (props: ISzfProductListPageViewProps) => {
    const { data: { categories }, config: { linkText }, app: { config: { festivalActivities, festivalActivitiesStaticSubNavItems } }, context: { request: { locale, apiSettings: { baseImageUrl }, sitePath } }, resources } = props;
    /* ZOHAIB | VSI | CUSTOMJIZATION | START */
    const merchandisingCategoryID = props.config.merchandisingCategoryID!;
    const merchandisingURLID = Number(props.context.request.urlTokens.recordId!);
    if(merchandisingURLID === merchandisingCategoryID){
        return null
    }
    /* ZOHAIB | VSI | CUSTOMJIZATION | END */
    const subCategories = categories.result?.filteredCategories;
    const parentCategory = categories.result?.parentCategory;
    const imageBaseURL = baseImageUrl?.substring(0, baseImageUrl?.length - 1);

    const handleOpenPlpSubCategory = (categoryId: number, categoryName: string | undefined): string => {
        const isSubCategory = festivalActivities.find((item: IFestivalCategory) => item.categoryId === categoryId);
        const isStaticNavItem = festivalActivitiesStaticSubNavItems.find((item: IFestivalActivitiesStaticSubNavItems) => categoryName?.toLowerCase().includes(item.categoryName.toLowerCase()));
        return isStaticNavItem ? `${window.location.origin}${sitePath}/festival-activities/${isStaticNavItem.categoryName?.toLowerCase()?.replace(/ /g,'-').replace('&','and')}` : isSubCategory ? `${window.location.origin}${window.location.pathname.replace(/\d+(?=\.c$)/, String(categoryId))}` : `${window.location.origin}${sitePath}/sub-festival-activities/${categoryName?.replace(/&/g, "and").replace(/\s/g, "-").toLowerCase()}?categoryId=${categoryId}`;
    };

    const getFestivalInfo = () => {
        const festivalActivity: IFestivalCategory = festivalActivities.find((item: IFestivalCategory) => item.categoryId === parentCategory?.RecordId);
        return locale.toLowerCase() === resources.arabic.toLowerCase() ? festivalActivity?.categorySubTextTranslation : festivalActivity?.categorySubText;
    };

    const _rendercategory = (
        category: Category,
        index: number
    ): JSX.Element => {
        const translatedText = category?.NameTranslations?.find((item: TextValueTranslation) => item.Language?.toLowerCase().includes(locale.toLowerCase()));
        return (
            <div key={index} className='festival-activities-item'>
                <div className='festival-activities-item__img'>
                    <img src={`${imageBaseURL}${category?.Name?.replace('&','And').replace(/\b(?<!')[a-z]/g, (match) => match.toUpperCase()).replace(',','')}__CLP__000.jpg`} />
                </div>
                <div className='msc-product'>
                    <div className='msc-product__img'>
                        <FestivalSVG />
                    </div>
                    <div className={`festival-activities-item__date`}>
                        <CalendarSVG />
                        <p>{category.LocalizedDescription?.split("__")![1]}</p>
                    </div>
                    <h2 className='msc-product__title'>{translatedText?.Text}</h2>
                </div>{' '}
                <p className='msc-product__desc'>
                    {category.LocalizedDescription?.split("__")![0]}
                </p>
                <div className={`festival-activities-item__cta`}>
                    {
                        msdyn365Commerce.isBrowser && window && (
                            <Button
                                href={handleOpenPlpSubCategory(category.RecordId, category.Name)}
                                name={category.Name}
                                id={`${category.RecordId}`}
                            >
                                {linkText}
                            </Button>
                        )
                    }
                </div>
            </div>
        );
    };

    return (
        <>
            {
                <div className={`festival-activities__info__${parentCategory?.Name?.replace(/ /g,'-').replace("&","and").toLowerCase()}`}>
                    <h5>
                        {
                            getFestivalInfo()
                        }
                    </h5>
                </div>
            } 
            <div className={`product-list-page__festivals__${parentCategory?.Name?.replace(/ /g, '-').replace("&", "and").toLowerCase()}`}>
                {subCategories && subCategories.length > 0 &&
                    subCategories.map((categoryItem, index) => {
                        return _rendercategory(categoryItem, index);
                    })}
            </div>
        </>
    );
};
